import {RouteInterface} from "../interfaces/RouteInterface";
import {Register} from "../features/public/Register/Register";
import ResetPassword from "../features/public/ResetPassword/ResetPassword";
import ForgotPassword from "../features/public/ResetPassword/ForgotPassword";
import { EconomicMarket } from "../features/public/EconomicMarket/EconomicMarket";
import Setup from "../features/public/Setup";
import Document from "../features/private/Document";
import { Confirm } from "../features/public/Confirm/Confirm";
import { Config } from "../features/public/Config/Config";
export const publicRoute: Array<RouteInterface> = [

    {path: '/economic-market', Component: EconomicMarket},
    {path: '/confirm', Component: Confirm},
    // Legacy CVR-password signup UI — disabled. Use /register (RegisterFromEconomic).
    // {path: '/config', Component: Config},
    {path: '/document', Component: Document},

]
